export enum GoingFastExperimentVariantTypes {
    visible = 'visible',
    hidden = 'hidden',
}
